/* eslint-disable import/no-cycle */
import { call, put, takeEvery, all } from 'redux-saga/effects';
import { stats } from '../../api/api';
import {
  GET_ALL_STATS,
  GET_SHIPPED_QUANTITIES_SUCCESS,
  GET_SHIPPED_QUANTITIES_FAILURE,
  GET_SHIPPED_QUANTITIES_TOP_SUCCESS,
  GET_SHIPPED_QUANTITIES_TOP_FAILURE,
  GET_AVERAGE_DELIVERY_DAYS_SUCCESS,
  GET_AVERAGE_DELIVERY_DAYS_FAILURE,
  GET_AVERAGE_DELIVERY_DAYS_TOP_SUCCESS,
  GET_AVERAGE_DELIVERY_DAYS_TOP_FAILURE,
  GET_QUANTITIES_BY_STATE_SUCCESS,
  GET_QUANTITIES_BY_STATE_FAILURE,
  GET_SHIPPED_QUANTITIES_BY_CARRIER_SUCCESS,
  GET_SHIPPED_QUANTITIES_BY_CARRIER_FAILURE,
  GET_SHIPPED_ITEMS_QUANTITIES_SUCCESS,
  GET_SHIPPED_ITEMS_QUANTITIES_FAILURE,
  GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_SUCCESS,
  GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_FAILURE,
  GET_PROCESSED_ITEMS_NATURES_QUANTITIES_SUCCESS,
  GET_PROCESSED_ITEMS_NATURES_QUANTITIES_FAILURE,
  GET_REASONS_QUANTITIES_SUCCESS,
  GET_REASONS_QUANTITIES_FAILURE,
  GET_RECEPTION_QUANTITIES_SUCCESS,
  GET_RECEPTION_QUANTITIES_FAILURE,
  GET_EXPECTED_PRODUCTS_QUANTITIES_SUCCESS,
  GET_EXPECTED_PRODUCTS_QUANTITIES_FAILURE,
  GET_ACTUAL_PRODUCTS_QUANTITIES_SUCCESS,
  GET_ACTUAL_PRODUCTS_QUANTITIES_FAILURE,
  GET_PROCESSED_QUANTITIES_SUCCESS,
  GET_PROCESSED_QUANTITIES_FAILURE,
  GET_MULTIPLE_EXCHANGES_QUANTITY_FAILURE,
  GET_MULTIPLE_EXCHANGES_QUANTITY_SUCCESS,
  GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_SUCCESS,
  GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_FAILURE,
  GET_SHIPPED_QUANTITIES,
  GET_SHIPPED_QUANTITIES_TOP,
  GET_AVERAGE_DELIVERY_DAYS,
  GET_AVERAGE_DELIVERY_DAYS_TOP,
  GET_QUANTITIES_BY_STATE,
  GET_SHIPPED_QUANTITIES_BY_CARRIER,
  GET_SHIPPED_ITEMS_QUANTITIES,
  GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES,
  GET_PROCESSED_ITEMS_NATURES_QUANTITIES,
  GET_REASONS_QUANTITIES,
  GET_RECEPTION_QUANTITIES,
  GET_EXPECTED_PRODUCTS_QUANTITIES,
  GET_ACTUAL_PRODUCTS_QUANTITIES,
  GET_PROCESSED_QUANTITIES,
  GET_MULTIPLE_EXCHANGES_QUANTITY,
  GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY
} from './dashboardActions';

import logger from '../../utils/logger';

/**
 * Récupération de la quantité de colis expédier
 * @param  {Object} payload payload object
 */
export function* getShippedQuantities({ payload }) {
  try {
    const response = yield call(stats.getShippedQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_SHIPPED_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_SHIPPED_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_SHIPPED_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération de la quantité de colis expédier pour la bulle du haut
 * @param  {Object} payload payload object
 */
export function* getShippedQuantitiesTop({ payload }) {
  try {
    const response = yield call(stats.getShippedQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_SHIPPED_QUANTITIES_TOP_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_SHIPPED_QUANTITIES_TOP_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_SHIPPED_QUANTITIES_TOP_FAILURE });
  }
}

/**
 * Récupération du temps de livraison moyen des colis expédier
 * @param  {Object} payload payload object
 */
export function* getAverageDeliveryDays({ payload }) {
  try {
    const response = yield call(stats.getAverageDeliveryDays, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_AVERAGE_DELIVERY_DAYS_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_AVERAGE_DELIVERY_DAYS_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_AVERAGE_DELIVERY_DAYS_FAILURE });
  }
}

/**
 * Récupération du temps de livraison moyen des colis expédier pour la bulle du haut
 * @param  {Object} payload payload object
 */
export function* getAverageDeliveryDaysTop({ payload }) {
  try {
    const response = yield call(stats.getAverageDeliveryDays, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_AVERAGE_DELIVERY_DAYS_TOP_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_AVERAGE_DELIVERY_DAYS_TOP_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_AVERAGE_DELIVERY_DAYS_TOP_FAILURE });
  }
}

/**
 * Récupération des quantitées de commandes par états
 * @param  {Object} payload payload object
 */
export function* getQuantitiesByStates({ payload }) {
  try {
    const response = yield call(stats.getQuantitiesByStates, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_QUANTITIES_BY_STATE_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_QUANTITIES_BY_STATE_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_QUANTITIES_BY_STATE_FAILURE });
  }
}

/**
 * Récupération des quantités expédiées par transporteur
 * @param  {Object} payload payload object
 */
export function* getShippedQuantitiesByCarrier({ payload }) {
  try {
    const response = yield call(stats.getShippedQuantitiesByCarrier, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_SHIPPED_QUANTITIES_BY_CARRIER_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_SHIPPED_QUANTITIES_BY_CARRIER_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_SHIPPED_QUANTITIES_BY_CARRIER_FAILURE });
  }
}

/**
 * Récupération des articles expédiés
 * @param  {Object} payload payload object
 */
export function* getShippedItemsQuantities({ payload }) {
  try {
    const response = yield call(stats.getShippedItemsQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_SHIPPED_ITEMS_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_SHIPPED_ITEMS_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_SHIPPED_ITEMS_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération des quantités de colis traités par nature
 * @param  {Object} payload payload object
 */
export function* getProcessedShipmentsNaturesQuantities({ payload }) {
  try {
    const response = yield call(
      stats.getProcessedShipmentsNaturesQuantities,
      payload
    );
    if (response.data.success === true) {
      yield put({
        type: GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération des quantités de produits traités par nature
 * @param  {Object} payload payload object
 */
export function* getProcessedItemsNaturesQuantities({ payload }) {
  try {
    const response = yield call(
      stats.getProcessedItemsNaturesQuantities,
      payload
    );
    if (response.data.success === true) {
      yield put({
        type: GET_PROCESSED_ITEMS_NATURES_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_PROCESSED_ITEMS_NATURES_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_PROCESSED_ITEMS_NATURES_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération de la quantité des raisons de retour
 * @param  {Object} payload payload object
 */
export function* getReasonsQuantities({ payload }) {
  try {
    const response = yield call(stats.getReasonsQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_REASONS_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_REASONS_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_REASONS_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération des quantités de réceptions par mois
 * @param  {Object} payload payload object
 */
export function* getReceptionsQuantities({ payload }) {
  try {
    const response = yield call(stats.getReceptionsQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_RECEPTION_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_RECEPTION_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_RECEPTION_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération des quantités de pièces annoncées par mois
 * @param  {Object} payload payload object
 */
export function* getExpectedProductsQuantities({ payload }) {
  try {
    const response = yield call(stats.getExpectedProductsQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_EXPECTED_PRODUCTS_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_EXPECTED_PRODUCTS_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_EXPECTED_PRODUCTS_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération des quantités de pièces contrôlées par mois
 * @param  {Object} payload payload object
 */
export function* getActualProductsQuantities({ payload }) {
  try {
    const response = yield call(stats.getActualProductsQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_ACTUAL_PRODUCTS_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_ACTUAL_PRODUCTS_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_ACTUAL_PRODUCTS_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération de la quantité de retours traités
 * @param  {Object} payload payload object
 */
export function* getProcessedQuantities({ payload }) {
  try {
    const response = yield call(stats.getProcessedQuantities, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_PROCESSED_QUANTITIES_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_PROCESSED_QUANTITIES_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_PROCESSED_QUANTITIES_FAILURE });
  }
}

/**
 * Récupération du nombre d’échanges multiples
 * @param  {Object} payload payload object
 */
export function* getMultipleExchangesQuantity({ payload }) {
  try {
    const response = yield call(stats.getMultipleExchangesQuantity, payload);
    if (response.data.success === true) {
      yield put({
        type: GET_MULTIPLE_EXCHANGES_QUANTITY_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_MULTIPLE_EXCHANGES_QUANTITY_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_MULTIPLE_EXCHANGES_QUANTITY_FAILURE });
  }
}

/**
 *
 * Récupération du nombre d’échanges suivis de remboursements
 * @param  {Object} payload payload object
 */
export function* getExchangesFollowedByRefundsQuantity({ payload }) {
  try {
    const response = yield call(
      stats.getExchangesFollowedByRefundsQuantity,
      payload
    );
    if (response.data.success === true) {
      yield put({
        type: GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({ type: GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY_FAILURE });
  }
}

/**
 *
 * Groupe de requête permettant de récupéré les données suivantes
 *
 * Asyncrone groupe 1
 *
 * Récupération de la quantité de colis expédier
 * Récupération du temps de livraison moyen des colis expédier
 * Récupération des quantitées de commandes par états
 *
 * Asyncrone groupe 2
 *
 * Récupération des quantités expédiées par transporteur
 * Récupération des articles expédiés
 *
 * Asyncrone groupe 3
 *
 * Récupération des quantités de colis traités par nature
 * Récupération des quantités de produits traités par nature
 * Récupération de la quantité des raisons de retour
 * Récupération de la quantité de retours traités
 * Récupération du nombre d’échanges multiples
 * Récupération du nombre d’échanges suivis de remboursements
 *
 * Asyncrone groupe 4
 *
 * Récupération des quantités de réceptions par mois
 * Récupération des quantités de pièces annoncées par mois
 * Récupération des quantités de pièces contrôlées par mois
 *
 * @param  {Object} action action object
 *
 */
export function* getAllStats(action) {
  try {
    // Groupe 1
    yield all([
      call(getShippedQuantities, {
        payload: action.payload.shippedQuantitiesParams
      }),
      call(getShippedQuantitiesTop, {
        payload: action.payload.shippedQuantitiesTopParams
      }),
      call(getAverageDeliveryDays, {
        payload: action.payload.averageDeliveryDaysParams
      }),
      call(getAverageDeliveryDaysTop, {
        payload: action.payload.averageDeliveryDaysTopParams
      }),
      call(getQuantitiesByStates, {
        payload: action.payload.quantitiesByStatesParams
      })
    ]);

    // Groupe 2
    yield all([
      call(getShippedQuantitiesByCarrier, {
        payload: action.payload.shippedQuantitiesByCarrierParams
      }),
      call(getShippedItemsQuantities, {
        payload: action.payload.shippedItemsQuantitiesParams
      })
    ]);

    // Groupe 3
    yield all([
      call(getProcessedShipmentsNaturesQuantities, {
        payload: action.payload.processedShipmentsNaturesQuantitiesParams
      }),
      call(getProcessedItemsNaturesQuantities, {
        payload: action.payload.processedItemsNaturesQuantitiesParams
      }),
      call(getReasonsQuantities, {
        payload: action.payload.reasonsQuantitiesParams
      }),
      call(getMultipleExchangesQuantity, {
        payload: action.payload.multipleExchangesQuantityParams
      }),
      call(getProcessedQuantities, {
        payload: action.payload.processedQuantitiesParams
      }),
      call(getExchangesFollowedByRefundsQuantity, {
        payload: action.payload.exchangesFollowedByRefundsQuantityParams
      })
    ]);

    // Groupe 4
    yield all([
      call(getReceptionsQuantities, {
        payload: action.payload.receptionQuantitiesParams
      }),
      call(getExpectedProductsQuantities, {
        payload: action.payload.expectedProductsQuantitiesParams
      }),
      call(getActualProductsQuantities, {
        payload: action.payload.actualProductsQuantitiesParams
      })
    ]);
  } catch (error) {
    logger(error);
  }
}

const dashboardSaga = [
  takeEvery(GET_ALL_STATS, getAllStats),
  takeEvery(GET_AVERAGE_DELIVERY_DAYS_TOP, getAverageDeliveryDaysTop),
  takeEvery(GET_SHIPPED_QUANTITIES, getShippedQuantities),
  takeEvery(GET_SHIPPED_QUANTITIES_TOP, getShippedQuantitiesTop),
  takeEvery(GET_AVERAGE_DELIVERY_DAYS, getAverageDeliveryDays),
  takeEvery(GET_QUANTITIES_BY_STATE, getQuantitiesByStates),
  takeEvery(GET_SHIPPED_QUANTITIES_BY_CARRIER, getShippedQuantitiesByCarrier),
  takeEvery(GET_SHIPPED_ITEMS_QUANTITIES, getShippedItemsQuantities),
  takeEvery(
    GET_PROCESSED_SHIPMENTS_NATURES_QUANTITIES,
    getProcessedShipmentsNaturesQuantities
  ),
  takeEvery(
    GET_PROCESSED_ITEMS_NATURES_QUANTITIES,
    getProcessedItemsNaturesQuantities
  ),
  takeEvery(GET_REASONS_QUANTITIES, getReasonsQuantities),
  takeEvery(GET_RECEPTION_QUANTITIES, getReceptionsQuantities),
  takeEvery(GET_EXPECTED_PRODUCTS_QUANTITIES, getExpectedProductsQuantities),
  takeEvery(GET_ACTUAL_PRODUCTS_QUANTITIES, getActualProductsQuantities),
  takeEvery(GET_PROCESSED_QUANTITIES, getProcessedQuantities),
  takeEvery(GET_MULTIPLE_EXCHANGES_QUANTITY, getMultipleExchangesQuantity),
  takeEvery(
    GET_EXCHANGES_FOLLOWED_BY_REFUNDS_QUANTITY,
    getExchangesFollowedByRefundsQuantity
  )
];

export default dashboardSaga;
